import ColorAdvancedForm from './ColorAdvancedForm'

export default ColorAdvancedForm
